import { useEffect, useState } from 'react';
import Approval from './Approval';
import Page1 from './Page1';
import Page2 from './Page2';
import Rejection from './Rejection';

type Props = {};

export default function Invitation({}: Props) {
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [componentToDisplay, setComponentToDisplay] = useState<JSX.Element>();

	const [questionSuccess, setQuestionSuccess] = useState<string>('');
	const [error, setError] = useState<string>('');

	function switchPage(component: JSX.Element) {
		document.querySelector('.page-holder')?.classList.remove('shown');

		setTimeout(() => {
			document.querySelector('.page-holder')?.classList.add('shown');
			setComponentToDisplay(component);
		}, 500);
	}

	useEffect(() => {
		switch (currentPage) {
			case 1: {
				switchPage(<Page1 />);
				break;
			}
			case 2: {
				switchPage(<Page2 questionSuccess={questionSuccess} setQuestionSuccess={setQuestionSuccess} />);
				break;
			}
			case 3: {
				if (questionSuccess === 'tak') {
					switchPage(<Approval />);
				} else {
					switchPage(<Rejection />);
				}

				break;
			}
		}
		setError('');
	}, [currentPage, questionSuccess]);

	return (
		<main className="text-white w-[80%] mx-auto p-8 border-customBlue border-2 rounded-md flex flex-col gap-10 mt-52 mb-20">
			<div className="page-holder flex flex-col gap-5">{componentToDisplay}</div>

			<span className={`transition-opacity bg-red-700 w-fit text-white px-3 py-1 rounded-md ${error ? 'opacity-100' : 'opacity-0'}`}>{error}</span>

			<div className="flex w-full justify-between items-center relative mt-auto">
				{currentPage > 1 && (
					<button className="pager-button mr-auto" onClick={() => setCurrentPage((prev) => prev - 1)}>
						Wstecz
					</button>
				)}
				<span className="absolute left-1/2 translate-x-[-50%] text-xl text-customBlue font-medium">{currentPage} / 3</span>
				{currentPage < 3 && (
					<button
						className="pager-button ml-auto"
						onClick={() => {
							if (currentPage === 2 && !questionSuccess) {
								setError('Proszę wybrać, którąś z opcji (sugerowałbym tą pierwszą)');
								return;
							}

							setCurrentPage((prev) => prev + 1);
						}}>
						Dalej
					</button>
				)}
			</div>
		</main>
	);
}
